import { Component, OnInit, OnDestroy,Injectable } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {ShareService} from './../services/services';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/publishReplay';

let headers = new Headers();
headers.append('Access-Control-Allow-Origin', '*');
headers.append('Content-Type', 'application/x-www-form-urlencoded');
let options = new RequestOptions({ headers: headers });	 

export class News {

    constructor(public slug: string, public image: string,public product_name: string,public product_description:string) { }
}

@Injectable()
export class NewsService {

  
     public _newslist;
    constructor(
      private http: Http,
      
      private shareService: ShareService) {
        this._newslist = null;
  
    }

	getNewslist(slug:string) {
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/newslist';
	   	if (!this._newslist) { 	     
        this._newslist = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
            }
            
         return this._newslist;

	}
	
	getLatestNews(limit:string) {
	    //console.log(slug);
	    let apirul=this.shareService.getApiUrl()+'/news';
	    let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	    if(limit)
	    {
		    apirul=apirul+'/'+limit;	
	    }
	  
	  
	   //	if (!this._galleryist) {     
         let output = this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);  
            
           //  }
          return output;
	    
	}
	getNewsdetail(slug:string) {
	   let headers = new Headers({'X-CSRF-TOKEN':this.shareService.getToken()});
	    headers.append('Access-Control-Allow-Origin', '*');
		headers.append('Content-Type', 'application/x-www-form-urlencoded');	
	    let options = new RequestOptions({ headers:headers });
	   	let apirul=this.shareService.getApiUrl()+'/newsdetail/'+slug;
	    	     
        let output= this.http.get(apirul,options)
             .map(res => res.json())
              .publishReplay(1)
			  .refCount()             
             .catch(this.handleError);
               
            
                      
         return output;

	    
	   	}
	
		
	handleError(error) {
        console.error("Got the error: " + JSON.stringify(error));
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/news/news.service.ts